<nav [ngClass]="{ 'navbar nav-style': !isEyefinityApp }">
  <div class="row w-100">
    <div class="col-4"></div>
    <div class="col-4 copyright-style text-center">
      <ng-container *ngIf="!isEyefinityApp">
        &copy; {{ today | date: 'yyyy' }} Eyefinity, Inc. All rights reserved.
        <br />Eyefinity is a registered trademark of Eyefinity, Inc.
      </ng-container>
      <a
        [ngClass]="
          isEyefinityApp ? ['vsp-footer-link', 'vsp-foot-item'] : 'linkOnFooter'
        "
        href="https://www.eyefinity.com/business-solutions/eWebExtra/eweb-terms-and-conditions.html"
        target="_blank"
        >Eyefinity Terms & Conditions</a
      >
    </div>
    <div
      *ngIf="version && !isEyefinityApp"
      [ngClass]="isEyefinityApp ? 'version' : ['vsp-version']"
      class="copyright-style text-end col-4"
    >
      Version: {{ version.version }} &nbsp;&nbsp;&nbsp; Build:
      {{ version.short }}
    </div>
  </div>
</nav>
